/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    workflows: [],
    total: 0,
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_WORKFLOWS:

            return {
                ...state,
                workflows: action.payload.data,
            }

        default: return state;

    }

}

export default reducer;
